export const NOT_A_NUMBER = /[^0-9]/g
export const pattern= {
  'eng': '[a-zA-Z]+',
  'kor': '[ㄱ-힣]+',
  'dec': '^\\d{1,{{limit}}}([.]{1}\\d{0,{{digits}}})?',
  'tel': '^\\d{1,3}([-]{1}\\d{0,4}){0,2}',
  'text-num': '[0-9]+',
  'text-num-eng': '[a-zA-Z0-9]',
  'num': '[0-9]+',
  'num-dot': '[0-9.]+',
  'num-bar': '[0-9-]+',
  'num-dot-bar': '[0-9.-]+',
  'num-comma': '[0-9,]+',
  'num-positive': '^[1-9][0-9]*',
  'dec-comma': '^[0-9,]{1,{{limit}}}([.]{1}\\d{0,{{digits}}})?',
  'no-symbol': '[^a-zA-Z0-9ㄱ-힣-_ ,.]',
  'no-symbol-strict': '[a-zA-Z0-9ㄱ-힣]|\\s{0,1}',
  'no-symbol-num': '[a-zA-Zㄱ-힣]+\\s*[a-zA-Zㄱ-힣]*',
  'eng-kor-num-space': '^[ㄱ-ㅎ가-힣a-zA-Z0-9\\s]+$',
  'only-character': '[a-zA-Zㄱ-힣]',
  'email-local': '[a-z0-9+.\\-_]',
  'email-domain': '[a-z0-9\\-+.]',
  'id': '([a-z]{1})([a-z0-9]{0,19})',
  'company-name': '[a-zA-Z0-9ㄱ-힣\\(\\)\']|\\s{0,1}',
  'phone': '[0-9\\-+\\(\\)]+',
  'hundred': '^([1-9]?[0-9]|100)$',
  'no-productname-special': '[^\\\\?"<>]',
  'no-product-special1': '[^\\\\?"*<>]',
  'no-product-special2': '[^\\\\:*?"<>※☆★○●◎◇◆□■△▲▽▼◁◀▷▶♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩]',
  'num-comma-space-enter': '[0-9,\\s\\n]+',
  'no-num': '[^0-9]+',
  'char-special': '[a-zA-Zㄱ-힣!@#$%^&+=\\-_.()]',
  'extra-management-cd': '[\\`\'"*?<>₩]',
  'ms-op-tag': '<(\/o:p|o:p)([^>]*)>',
}